/* Automatic homepage invitation; native Shopify newsletter signup remains intact. */
(() => {
 const dialog=document.getElementById('atelier-newsletter');
 if(!dialog||dialog.dataset.popupInitialized)return;
 dialog.dataset.popupInitialized='true';
 const key='stoooff-newsletter-v1',sessionKey='stoooff-newsletter-shown';
 const read=()=>{try{return JSON.parse(localStorage.getItem(key)||'{}')}catch{return {}}};
 const write=state=>{try{localStorage.setItem(key,JSON.stringify(state))}catch{}};
 const sessionShown=()=>{try{return sessionStorage.getItem(sessionKey)==='true'}catch{return false}};
 const markShown=()=>{try{sessionStorage.setItem(sessionKey,'true')}catch{}};
 const success=Boolean(dialog.querySelector('[data-newsletter-success]'));
 const subscriber=dialog.dataset.subscribed==='true'||success;
 if(subscriber)write({...read(),subscribed:true});
 function open(){if(!dialog.open&&typeof dialog.showModal==='function'){dialog.showModal();markShown()}}
 dialog.addEventListener('close',()=>{
  if(!subscriber&&!read().subscribed)write({...read(),dismissedUntil:Date.now()+30*24*60*60*1000});
 });
 // Native Escape closes the dialog; the visible cross works independently of other scripts.
 dialog.querySelector('.close')?.addEventListener('click',()=>dialog.close());
 document.querySelectorAll('a[href="#atelier-newsletter"]').forEach(link=>link.addEventListener('click',event=>{event.preventDefault();open()}));
 if(dialog.querySelector('[data-newsletter-result]')){open();return}
 const state=read();
 if(subscriber||state.subscribed||Number(state.dismissedUntil)>Date.now()||sessionShown())return;
 setTimeout(()=>{
  // Do not interrupt another dialog or an active form entry.
  if(document.visibilityState==='hidden'||document.querySelector('dialog[open]')||/^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement?.tagName||''))return;
  open();
 },5000);
})();
